import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'search',
	prefix: 'search',
	key: 'search_id',
	fields: {
		search_id: Model.SCHEMA_NUMBER,
		search_date: Model.SCHEMA_DATE_CREATE,
		search_type: Model.SCHEMA_NUMBER,
		search_key: Model.SCHEMA_TEXT,
		search_filter: Model.SCHEMA_JSON,
		search_config: Model.SCHEMA_JSON,
		search_total: Model.SCHEMA_NUMBER,
		search_total_max: Model.SCHEMA_NUMBER,
		search_total_pseudo: Model.SCHEMA_NUMBER,
		search_total_nested: Model.SCHEMA_NUMBER,
		search_index: Model.SCHEMA_TEXT,
		search_games: Model.SCHEMA_TEXT,
		search_users: Model.SCHEMA_TEXT,
		search_nested: Model.SCHEMA_TEXT,
		search_data_id: Model.SCHEMA_NUMBER,
		search_data_session: Model.SCHEMA_NUMBER,
		search_data_api: Model.SCHEMA_TEXT,
		search_data_type: Model.SCHEMA_NUMBER,
		search_data_version: Model.SCHEMA_NUMBER,
		search_usage: Model.SCHEMA_NUMBER,
		search_duration: Model.SCHEMA_NUMBER
	},
	methods: {
		get_game_index: function() {
			return this.get_games() ? String(this.get_games()).split(',').map(Number) : []
		},
		get_result_index: function() {
			return this.get_index() ? String(this.get_index()).split(',').map(Number) : []
		},
		get_user_index: function() {
			return this.get_users() ? String(this.get_users()).split(',').map(Number) : []
		},
		get_nested_index: function() {
			return this.get_nested() ? String(this.get_nested()).split(',').map(Number) : []
		}
	}
})
